<ng-container [ngSwitch]="output?.type">
  <h3-point-cloud-output
    *ngSwitchCase="'PointCloudOutput'"
    [id]="idAttribute"
  ></h3-point-cloud-output>
  <h3-image-annotation-output
    *ngSwitchCase="'ImageAnnotationOutput'"
    [id]="idAttribute"
  ></h3-image-annotation-output>
  <h3-video-output
    *ngSwitchCase="'VideoOutput'"
    [id]="idAttribute"
  ></h3-video-output>
  <h3-nestable-output
    *ngSwitchDefault
    [id]="idAttribute"
    [outputInfoStore]="outputInfoStore!"
  ></h3-nestable-output>
</ng-container>
